import z from 'zod'
import { ApiSecretRequiredException } from '../../errors'
import type { FetchSubTypes } from '../../types'
import { createClient } from '../createClient'

export const fetchSubTypes: FetchSubTypes = async ({
  apiKey,
  apiSecret,
  createHeaders,
  proxy,
}) => {
  if (!apiSecret) {
    throw new ApiSecretRequiredException()
  }

  const client = createClient({
    apiKey,
    apiSecret,
    noAuth: true,
    createHeaders,
    proxy,
  })

  const response = await client.run({
    method: 'GET',
    path: '/api/v3/exchangeInfo',
    query: {
      permissions: 'SPOT',
      showPermissionSets: 'false',
    },
    responseSchema,
  })

  const subTypes = new Set<string>()
  for (const symbol of response.symbols) {
    subTypes.add(`${symbol.baseAsset}/${symbol.quoteAsset}`)
  }

  return [...subTypes].sort((a, b) => a.localeCompare(b))
}

const responseSchema = z.object({
  symbols: z.array(
    z.object({
      symbol: z.string(),
      baseAsset: z.string(),
      quoteAsset: z.string(),
    }),
  ),
})
